import { motion } from 'framer-motion'
import { withTranslation } from 'react-i18next'

import {
  PaymentMethodBorder,
  PaymentMethodIcon,
  PaymentMethodLabel,
  PaymentMethodOutline,
  PaymentMethodWrapper
} from './PaymentMethod.styles'

const IconsLibrary = {
  blik: 'img/blik.png',
  creditCard: 'img/credit-card.png',
  cash: 'img/wallet.png'
}

const PaymentMethod = ({ t, label, onClick, active, value }) => {
  const image = IconsLibrary[value]

  return (
    <PaymentMethodWrapper onClick={onClick} active={active}>
      <PaymentMethodBorder />
      <PaymentMethodOutline as={motion.div} />
      <PaymentMethodLabel>{t(`paymentMethodsLabels.${label}`)}</PaymentMethodLabel>
      <PaymentMethodIcon src={image}></PaymentMethodIcon>
    </PaymentMethodWrapper>
  )
}

export default withTranslation()(PaymentMethod)
